module.exports = __webpack_public_path__ + "img/bg-image-communities.b68d7fd5.png";